<script lang="ts">
	export let enabled = true;
</script>

<div class:layer-chart-spacing={enabled}>
	<slot />
</div>

<style>
	.layer-chart-spacing {
		min-width: 0;
		box-sizing: border-box;
		padding-right: 16px;
		padding-left: 32px;
	}

	.layer-chart-spacing :global(.layer-chart-theme .lc-area-chart) {
		box-sizing: border-box;
		border: 1px solid hsl(0 0% 100% / 0.12);
		border-radius: 16px;
		background: hsl(0 0% 0% / 0.08);
	}

	.layer-chart-spacing :global(.layer-chart-theme .lc-card-tooltip) {
		max-width: calc(100% - 16px);
		pointer-events: none !important;
	}

	@media (max-width: 480px) {
		.layer-chart-spacing {
			padding-right: 8px;
			padding-left: 24px;
		}
	}
</style>
